import ztComponent from './ztIcon.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
